export const ApplicationSettingKeys = {
  CreditAwardDelay: "DustClass.CreditAwardDelay",
  CreditExpiry: "DustClass.CreditExpiry",
  PublicClassLockLead: "DustClass.PublicClassLockLead",
  AttendeeReminderLead: "DustClass.AttendeeReminderLead",
  PaymentDue: "DustClass.PaymentDue",
  UnpaidCancelResume: "DustClass.UnpaidCancelResume",
  CardValidity: "DustClass.CardValidity",
  VeeGrace: "DustMonitorCard.VeeGrace",
  InvitationResend: "DustMonitorClass.InvitationResend",
  InvoicePoll: "ClassRegistration.InvoicePoll",
  ClassRegistrationCron: "Jobs.ClassRegistrationCron",
  PrivateClassMinimumAttendees: "DustClass.PrivateClassMinimumAttendees",
  DustMonitorOverflowThreshold: "DustMonitorClass.OverflowThreshold",
  OperatingPermitDuration: "DustPermit.OperatingPermitDuration",
  TemporaryCommercialActivityDuration: "DustPermit.TemporaryCommercialActivityDuration",
} as const;

export const ApplicationSettingDefaults = {
  PrivateClassMinimumAttendees: 20,
} as const;

export type ApplicationSettingKey = (typeof ApplicationSettingKeys)[keyof typeof ApplicationSettingKeys];

export type ApplicationSettingDurationUnit = "days" | "months" | "years" | "minutes";

export interface ApplicationSetting {
  key: string;
  value: string;
  valueType: string;
  description?: string | null;
  unit?: ApplicationSettingDurationUnit | null;
  durationMilliseconds?: number | null;
}
